
import { mapActions, mapGetters } from 'vuex'
import store from '../config/store'
import LoaderSpinner from '../components/LoaderSpinner.vue'
import { checkCompletedInputs } from '../helpers/utils/util'

export default {
  components: {
    LoaderSpinner
  },

  data: () => ({
    store,
    active: false,
    accountsLoading: false,
    filter: '',
    enterTimer: null
  }),

  computed: {
    ...mapGetters([
      'accounts',
      'accountsCurrentPage',
      'accountsLastPage'
    ]),

    groupedAccounts () {
      return this.accounts.reduce((r, a) => {
        const name = a.label
        r[name] = r[name] || []
        r[name].push(a)
        return r
      }, Object.create(null))
    },

    account () {
      var id = store.data.user.default_account_uuid
      console.log('account id', id)
      console.log('access', store.data.user.account.access)
      return store.data.user.account
    },
  },

  watch: {
    active () {
      if (!this.active) {
        this.filter = ''
      }
    }
  },

  mounted () {
    this.$bus.$on('show-account-picker', this.showAccountPicker)
    this.$bus.$on('hide-account-picker', this.hideAccountPicker)
  },

  destroyed () {
    this.$bus.$off('show-account-picker', this.showAccountPicker)
    this.$bus.$off('hide-account-picker', this.hideAccountPicker)
  },

  methods: {
    ...mapActions([
      'getAccounts',
      'switchAccount'
    ]),

    getUserAccounts (nextPage = false) {
      if (this.enterTimer) {
        clearTimeout(this.enterTimer)
      }
      this.enterTimer = setTimeout(() => {
        this.accountsLoading = true
        const filter = { search: this.filter }
        if (nextPage) {
          filter.page = this.accountsCurrentPage + 1
        }
        this.getAccounts(filter).then(() => {
          this.accountsLoading = false
        })
      }, 500)
    },

    hideAccountPicker () {
      this.active = false
    },

    showAccountPicker () {
      this.getUserAccounts()
      this.active = true
    },

    hasBalance (accountItem) {
      return accountItem.balance !== null && accountItem.hasOwnProperty('balance')
    },

    hasRib(item) {
      return item.rib && item.rib.account_number
    },

    onAccountClick (account) {
      this.changeAccount(account)
    },

    changeAccount (account) {
      this.switchAccount(account)
      this.active = false
    }
  }
}
